import React, { FC } from 'react';
import PropTypes from 'prop-types';
import './style.scss';

interface UploadFileRequirementsProps {
  visible: boolean;
}

const UploadFileRequirements: FC<UploadFileRequirementsProps> = ({ visible }): JSX.Element => (
  <div className="la1-upload-req" style={{ maxHeight: +visible * 185 }} data-testid="upload-requirements-wrapper">
    <div className="la1-upload-req-inner-wrap">
      <div className="la1-upload-req-header">File Requirements</div>
      <div className="la1-upload-req-container">
        <div className="la1-upload-req-item"><b>Video Codec:</b> H.264</div>
        <div className="la1-upload-req-item"><b>Number of Video Channels:</b> 1</div>
        <div className="la1-upload-req-item"><b>Number of Audio Channels:</b> 2</div>
        <div className="la1-upload-req-item"><b>Max video resolution:</b> 1920x1080</div>
        <div className="la1-upload-req-item"><b>Max Keyframe Interval:</b> 3.2 seconds</div>
        <div className="la1-upload-req-item"><b>Max Audio Bitrate:</b> 192 Kbps</div>
        <div className="la1-upload-req-item"><b>Scan Type:</b> Progressive (Required for Web)</div>
        <div className="la1-upload-req-item"><b>Framerate:</b> 23.976, 25, 29.97, 30, 50, 59.94, 60</div>
        <div className="la1-upload-req-item"><b>Audio Codec:</b> AAC-LE, AAC-HE</div>
        <div className="la1-upload-req-item"><b>Audio Sample Rate:</b> 48 kHz</div>
        <div className="la1-upload-req-item"><b>Max video bitrate:</b> 6 Mbps up to 30 fps / 8 Mbps up to 60 fps</div>
      </div>
    </div>
  </div>
)

UploadFileRequirements.displayName = 'UploadFileRequirements';

UploadFileRequirements.propTypes = {
  visible: PropTypes.bool.isRequired,
};

export default UploadFileRequirements;